<template>
  <div v-if="shares">
    <div style="background-color: #fff" class="row m-2 p-2 border">
      <div class="col">
        <img src="./proxmox.png" height="35" class="m-3" /> Сервер виртуальных
        машин
        <table class="table table-sm table-striped">
          <thead>
            <th>Номер</th>
            <th>Ядер</th>
            <th>ЦПУ</th>
            <th>Память</th>
            <th>Сеть вход</th>
            <th>Сеть выход</th>
            <th>Диск чт.</th>
            <th>Диск зп.</th>
          </thead>
          <tbody>
            <tr v-for="(vm, index) of shares.vm" :key="index">
              <td>{{vm.id}}</td>
              <td>{{vm.cpus}}</td>
              <td>{{Math.floor(vm.cpu * 100) + '%'}}</td>
              <td>{{Math.floor(vm.mem / (vm.maxmem / 100)) + '%'}}</td>
              <td>{{hS(vm.netinintime)}}</td>
              <td>{{hS(vm.netoutintime)}}</td>
              <td>{{hS(vm.diskreadintime)}}</td>
              <td>{{hS(vm.diskwriteintime)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Proxmox",

  props: ["info", "shares", "id"],
  methods: {
    hS: function (bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;
      if (Math.abs(bytes) < thresh) return bytes.toFixed(dp) + " B";
      const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
      let u = -1;
      const r = 10 ** dp;
      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
      );
      return bytes.toFixed(dp) + " " + units[u];
    },
  },
};
</script>
<style scoped>
</style>
